import { Text, HbTooltip } from '@cdl/heartbeat-react';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { shrIntervalSelector } from '../../wave/selectors/wave.selectors';
import { useStrip } from '../hooks/useStrip';
import { TEXT_OFFSET } from '../utils/graph.utils';

export const ShrIntervals: React.FC = () => {
  const { xScale } = useStrip();
  const intervals = useSelector(shrIntervalSelector);

  return (
    <>
      {intervals.map((interval, i) => (
        <HbTooltip hasArrow label='Sustained HR' key={i}>
          <g
            key={interval.timestamp}
            transform={`translate(${xScale(
              interval.timestamp,
            )}, ${TEXT_OFFSET})`}
          >
            <Text
              as='text'
              fontWeight='bold'
              fill='purple.500'
              cursor='default'
            >
              {Math.round(interval.shr)}
            </Text>
          </g>
        </HbTooltip>
      ))}
    </>
  );
};
